const unCamelCase = (val: string) =>
  val
    // split an acronym from a following capitalized word: "CIPReport" -> "CIP Report"
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    // split a lowercase/digit from an uppercase letter: "healthPlan" -> "health Plan"
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim();

export default unCamelCase;
